import React from 'react'
import { Calendar as BigCalendar, momentLocalizer } from 'react-big-calendar'
import moment from 'moment'
import PropTypes from 'prop-types'
import $ from 'jquery'
import { connect } from 'react-redux'
import { withTranslation } from 'react-i18next'
import { fromZonedTime } from 'date-fns-tz'
import { startOfMonth, endOfMonth, subDays, addDays } from 'date-fns'

import OrderPersonaTrainingPopup from '../Popups/OrderPersonalTrainingPopup'
import { selectUserData } from '../../reducers/userDataReducer'
import withHookSnackbar from '../../helpers/hooks/hocUseSnackbar'
import { setTrainingsDates, setTrainings } from '../../reducers/trainingsReducer'

import { getCalendarMessages } from './calendarMessages'
import MonthEvent from './MonthEvent'
import WeekEvent from './WeekEvent'
import CalendarToolbar from './CalendarToolbar'
import API from './../../api/api'
import CalendarCell from './CalendarCell'
import CalendarMonth from './CalendarMonth'
import DayEvent from './DayEvent'
import CalendarPopup from './CalendarPopup'
import TrainingDetails from './../Popups/TrainingDetails'
import CancelPopup from './../Popups/CancelPopup'
import CancelConfirmation from './../Popups/CancelConfirmation'
import { getTrainingType, parseEventsForCalendar } from './../../helpers/helpers'
import { CALENDAR_RANGE_PADDING_DAYS } from './../../helpers/constants'
import AgendaEvent from './AgendaEvent'

class CalendarUser extends React.Component {
  constructor(props) {
    super(props)
    this.showPopup = this.showPopup.bind(this)
    this.hidePopup = this.hidePopup.bind(this)
    this.selectEvent = this.selectEvent.bind(this)
    this.selectSlot = this.selectSlot.bind(this)
    this.calculatePopupPosition = this.calculatePopupPosition.bind(this)
    this.displayTimeIndicator = this.displayTimeIndicator.bind(this)
    this.handleOnView = this.handleOnView.bind(this)
    this.handleOnNavigate = this.handleOnNavigate.bind(this)
    this.handlePopupUpdate = this.handlePopupUpdate.bind(this)
    this.selectTrainingsForPopup = this.selectTrainingsForPopup.bind(this)
    this.getTrainings = this.getTrainings.bind(this)
    const minTime = new Date()
    const maxTime = new Date()
    minTime.setHours(6, 0, 0)
    maxTime.setHours(23, 0, 0)
    this.state = {
      currentCalendarView: 'month',
      currentCalendarDay: new Date(),
      weekDayMin: minTime,
      weekDayMax: maxTime,
      popupEvents: [],
      trainingUpdate: false,
      activeTraining: null,
      activePopup: '',
      isCalendarVisible: false,
    }
  }

  getTrainings(start, end) {
    const { dispatch, userData, displaySnackbar, t } = this.props
    const handleError = () => displaySnackbar(t('calendar:errors.loadSchedule'), true)
    if (userData.buildingId !== null && userData.buildingId.id) {
      API.getBuildingSchedule(start, end)
        .then((trainings) => dispatch(setTrainings(trainings)))
        .catch(handleError)
    } else {
      API.getUserSchedule(start, end)
        .then((trainings) => dispatch(setTrainings(trainings)))
        .catch(handleError)
    }
  }

  selectTrainingsForPopup(start, end) {
    const dayStart = start
    const dayEnd = end
    const { trainings } = this.props.calendar
    const filteredEvents = trainings.filter((e) => {
      if (e.date >= dayStart && e.date <= dayEnd) {
        return e
      }
    })
    filteredEvents.sort((a, b) => {
      return parseInt(a.date) >= parseInt(b.date)
    })
    this.setState({ popupEvents: filteredEvents })
  }

  componentDidMount() {
    const { dispatch, userData } = this.props
    const start = subDays(
      startOfMonth(fromZonedTime(new Date(), userData?.buildingId?.timezone || 'America/Chicago')),
      CALENDAR_RANGE_PADDING_DAYS,
    ).getTime()

    const end = addDays(
      endOfMonth(fromZonedTime(new Date(), userData?.buildingId?.timezone || 'America/Chicago')),
      CALENDAR_RANGE_PADDING_DAYS,
    ).getTime()

    if (userData.buildingId === null && userData.trainerId === null) {
      this.handlePopupUpdate('order-personal-training-popup')
    }
    dispatch(setTrainingsDates(start, end))
    this.getTrainings(start, end)
    setTimeout(() => {
      this.setState({ isCalendarVisible: true })
    }, 300)
  }

  handlePopupUpdate(popup, training, refreshTrainings) {
    this.setState({
      trainingUpdate: refreshTrainings ? !this.state.trainingUpdate : this.state.trainingUpdate,
      activeTraining: training,
      activePopup: popup,
    })
    this.hidePopup()
  }

  componentWillReceiveProps() {
    this.hidePopup()
  }
  componentWillUpdate(nextProps, nextState) {
    if (this.state.trainingUpdate !== nextState.trainingUpdate) {
      const { startDate, endDate } = this.props.calendar
      this.getTrainings(startDate, endDate)
    }
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevState.activePopup) $(`.ctp-${prevState.activePopup}`).css('display', 'none')
    if (this.state.activePopup) $(`.ctp-${this.state.activePopup}`).css('display', 'flex')
  }

  showPopup(_event) {
    if (this.state.currentCalendarView === 'month') $('.ctp-popup').addClass('ctp-popup--active')
  }

  hidePopup() {
    if (this.state.currentCalendarView === 'month') {
      $('.ctp-popup')
        .removeClass('ctp-popup--active')
        .removeClass('ctp-popup--left-pos')
        .removeClass('ctp-popup--bottom-pos')
        .removeClass('ctp-popup--top-pos')
      this.handleCalendarCell('hide')
      this.setState({ popupEvents: [] })
    }
  }

  handleCalendarCell(action, date) {
    switch (action) {
      case 'show':
        $(`.ctp-calendar__cell[data-event-date="${date}"]`).addClass('ctp-calendar__cell--active')
        break
      case 'hide':
        $('.ctp-calendar__cell--active').removeClass('ctp-calendar__cell--active')
    }
  }

  calculatePopupPosition(target) {
    const popup = $('.ctp-popup')
    const calendar = $('.rbc-calendar')
    const montRow = target.closest('.rbc-month-row')
    const toolbar = $('.rbc-toolbar')
    const header = $('.rbc-header')
    const arrow = $('.ctp-popup__arrow')
    const calculateXposition = () => {
      popup.css({ left: 'auto', right: 'auto' })
      if (calendar.width() - (target.offset().left + target.width()) > popup.width()) {
        popup.css({ left: target.offset().left + target.width() + 1 })
      } else {
        popup.css({ left: target.offset().left - popup.width() + 1 })
        popup.addClass('ctp-popup--left-pos')
      }
    }
    const calculateYposition = () => {
      popup.css({ top: 'auto', bottom: 'auto' })
      arrow.css({ top: 'auto', bottom: 'auto' })
      const calculatedTopPosition =
        montRow.offset().top - calendar.offset().top - popup.height() / 2 + montRow.height() / 2
      if (calculatedTopPosition < toolbar.height() + header.height()) {
        popup.css({ top: toolbar.height() + header.height() })
        arrow.css({ top: montRow.offset().top - calendar.offset().top })
      } else {
        if (calendar.height() - popup.height() > calculatedTopPosition) {
          popup.css({ top: calculatedTopPosition })
          arrow.css({ top: '50%' })
        } else {
          popup.css({ bottom: 0 })
          arrow.css({ bottom: calendar.height() - montRow.offset().top })
        }
      }
    }
    calculateXposition()
    calculateYposition()
    $(window).on('resize', () => {
      this.hidePopup()
    })
  }

  displayTimeIndicator() {
    const { currentCalendarView, currentCalendarDay } = this.state
    if (!moment().isSame(currentCalendarDay, currentCalendarView)) {
      $('.rbc-current-time-indicator').addClass('is-hidden')
    } else {
      $('.rbc-current-time-indicator').removeClass('is-hidden')
    }
  }

  selectEvent(event) {
    if (this.state.currentCalendarView === 'month') {
      const date = moment(event.start).format('DD-MM-YYYY')
      this.hidePopup()
      this.handleCalendarCell('show', date)
      this.selectTrainingsForPopup(
        moment(event.date).startOf('day').toDate().getTime(),
        moment(event.date).endOf('day').toDate().getTime(),
      )
      setTimeout(() => {
        this.calculatePopupPosition($(`.ctp-calendar__cell[data-event-date="${date}"]`))
        this.showPopup()
      }, 10)
    } else {
      this.handlePopupUpdate('training-details', event, false)
    }
  }

  selectSlot(slotInfo) {
    if ($('.ctp-popup').hasClass('ctp-popup--active')) {
      this.hidePopup()
    } else if (this.state.currentCalendarView === 'month') {
      const date = moment(slotInfo.start).format('DD-MM-YYYY')
      this.hidePopup()
      this.handleCalendarCell('show', date)
      this.selectTrainingsForPopup(
        slotInfo.start.getTime(),
        moment(slotInfo.end).endOf('day').toDate().getTime(),
      )
      this.calculatePopupPosition($(`.ctp-calendar__cell[data-event-date="${date}"]`))
      this.showPopup()
    }
  }

  handleOnView(e) {
    this.hidePopup()
    this.setState({ currentCalendarView: e }, () => {
      this.displayTimeIndicator()
    })
  }

  handleOnNavigate(e) {
    this.hidePopup()
    const { dispatch, userData } = this.props

    const start = subDays(
      startOfMonth(fromZonedTime(e, userData?.buildingId?.timezone || 'America/Chicago')),
      CALENDAR_RANGE_PADDING_DAYS,
    ).getTime()

    const end = addDays(
      endOfMonth(fromZonedTime(e, userData?.buildingId?.timezone || 'America/Chicago')),
      CALENDAR_RANGE_PADDING_DAYS,
    ).getTime()

    dispatch(setTrainingsDates(start, end))
    this.getTrainings(start, end)
    this.setState({ currentCalendarDay: e }, () => {
      this.displayTimeIndicator()
    })
  }

  renderPopup() {
    const { userData } = this.props
    if (this.state.CurrentCalendarView !== 'month' && this.state.activeTraining) {
      const { activePopup, activeTraining } = this.state
      switch (activePopup) {
        case 'training-details':
          return (
            <TrainingDetails
              training={activeTraining}
              type={
                getTrainingType(activeTraining) === 'appointment' ||
                (typeof activeTraining.signed !== 'undefined' && activeTraining.signed === true)
                  ? 'cancel'
                  : activeTraining.cost === 0
                    ? 'free'
                    : 'paid'
              }
              onUpdate={this.handlePopupUpdate}
              userData={this.props.userData}
            />
          )
        case 'cancel-popup':
          return <CancelPopup training={activeTraining} onUpdate={this.handlePopupUpdate} />
        case 'cancel-confirmation':
          return <CancelConfirmation onUpdate={this.handlePopupUpdate} />
        case 'order-personal-training-popup':
          return <OrderPersonaTrainingPopup onUpdate={this.handlePopupUpdate} userData={userData} />
        default:
          return {}
      }
    } else {
      const { activePopup } = this.state
      switch (activePopup) {
        case 'cancel-confirmation':
          return <CancelConfirmation onUpdate={this.handlePopupUpdate} />
        case 'order-personal-training-popup':
          return <OrderPersonaTrainingPopup onUpdate={this.handlePopupUpdate} userData={userData} />
      }
    }
  }
  render() {
    const { trainings, onlyMyActivities } = this.props.calendar
    const { userData } = this.props
    let filteredTrainings = trainings.slice()
    if (onlyMyActivities) {
      filteredTrainings = filteredTrainings.filter((training) => {
        return training.signed || training.mainClient === userData.id
      })
    }

    filteredTrainings = parseEventsForCalendar(filteredTrainings)

    return (
      <div className={`ctp-calendar ctp-calendar--${this.state.currentCalendarView}`}>
        {this.state.isCalendarVisible && (
          <BigCalendar
            localizer={momentLocalizer(moment)}
            selectable={this.state.currentCalendarView === 'month'}
            popup
            views={{ month: true, week: true, day: true, agenda: true }}
            events={[...filteredTrainings]}
            messages={getCalendarMessages(this.props.t)}
            components={{
              toolbar: CalendarToolbar,
              dateCellWrapper: CalendarCell,
              month: {
                event: MonthEvent,
                month: CalendarMonth,
              },
              week: {
                event: WeekEvent,
              },
              day: {
                event: DayEvent,
              },
              agenda: {
                event: AgendaEvent,
              },
            }}
            view={this.state.currentCalendarView}
            onView={this.handleOnView}
            onNavigate={this.handleOnNavigate}
            onSelectSlot={this.selectSlot}
            onSelectEvent={this.selectEvent}
            min={this.state.weekDayMin}
            max={this.state.weekDayMax}
            defaultDate={new Date()}
          />
        )}
        <CalendarPopup
          trainings={this.state.popupEvents}
          onHidePopup={this.hidePopup}
          onUpdate={this.handlePopupUpdate}
          userData={userData}
        />
        {this.renderPopup()}
      </div>
    )
  }
}

CalendarUser.propTypes = {
  calendar: PropTypes.object,
  userData: PropTypes.object,
  dispatch: PropTypes.func,
  startDate: PropTypes.object,
  endDate: PropTypes.object,
  t: PropTypes.func,
  displaySnackbar: PropTypes.func,
}

export default connect((state) => ({
  ...state,
  calendar: state.trainings,
  userData: selectUserData(state),
}))(withTranslation(['calendar'])(withHookSnackbar(CalendarUser)))
